import { render, staticRenderFns } from "./legado_vetus.vue?vue&type=template&id=772840a6&scoped=true&"
import script from "./legado_vetus.vue?vue&type=script&lang=js&"
export * from "./legado_vetus.vue?vue&type=script&lang=js&"
import style0 from "./legado_vetus.vue?vue&type=style&index=0&id=772840a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772840a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VCardTitle,VTab,VTabItem,VTabs,VTabsItems})
